import {BaseModuleState} from "../../../../../infrastructure/models/base-module-state";
import {computed, override} from "mobx";
import {CompetitionHeaderViewModel} from "../../../models/competition-header.view-model";
import {CompetitorHeaderViewModel} from "../../../models/competitor-header.view-model";
import {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {BaseHeaderViewModel} from "../../../models/base-header.view-model";
import {BaseMobxState} from "../../../../../infrastructure/mobx/base-mobx-state";
import {AppStore} from "../../../../../core/app/app-store";
import {LoggerUtils} from "../../../../../infrastructure/utils/logger/logger-utils";
import {DatetimeUtils} from "../../../../../infrastructure/utils/datetime-utils";
import {DeviceViewModel} from "../../../../../core/models/device.view-model";
import {TermsUtils} from "../../../../../infrastructure/utils/terms-utils";
import {NavigationManager} from "../../../../../core/managers/navigation-manager";
import {ROUTE_NAMES} from "../../../../../core/consts";
import {BaseLinkModelSettings} from "../../../../../infrastructure/models/link/base-link-model-settings";
import {EntitiesResponseDomainModel} from "../../../../../domain/entities/models/entities.response-domain-model";
import {CompetitionDomainModel} from "../../../../../domain/common/competition/models/competition-domain-model";
import {CompetitorDomainModel} from "../../../../../domain/common/competitor/models/competitor-domain-model";

export class EntityHeaderModuleState extends BaseModuleState {
  static injectables = [...BaseMobxState.injectables, NavigationManager, AppStore, LoggerUtils, DatetimeUtils, DeviceViewModel, TermsUtils];
  dataSource: EntitiesResponseDomainModel;

  @computed get entityHeaderModel(): BaseHeaderViewModel {
    let header = null;

    if (this.selectedCompetition || this.selectedCompetitor) {
      const selections = {
        [ROUTE_NAMES.competitionScores]: () => new CompetitionHeaderViewModel(this.terms, this.navigationManager, this.selectedCompetition, this.device.isSmallView, this.minFollowValue),
        [ROUTE_NAMES.competitorScores]: () => new CompetitorHeaderViewModel(this.terms, this.navigationManager, this.selectedCompetitor, this.device.isSmallView, this.minFollowValue),
        [ROUTE_NAMES.game]: () => new CompetitionHeaderViewModel(this.terms, this.navigationManager, this.selectedCompetition, this.device.isSmallView, this.minFollowValue),
      };
      header = selections[this.currentLinkModel.name]();
    }

    return header;
  }

  @computed get selectedCompetition(): CompetitionDomainModel {
    const selectedCompetition: CompetitionDomainModel = this.dataSource?.competitions?.find(
      (competition: CompetitionDomainModel) => competition.id === this.competitionId);

    return selectedCompetition;
  }

  @computed get selectedCompetitor(): CompetitorDomainModel {
    const selectedCompetitor: CompetitorDomainModel = this.dataSource?.competitors?.find(
      (competitor: CompetitorDomainModel) => competitor.id === this.entityId);

    return selectedCompetitor;
  }

  get competitionId(): Number {
    let competitionId: Number = this.entityId;

    if (!this.entityId) {
      competitionId = parseInt(this.currentLinkModel?.params.competitionKey?.split('-').last())
    }

    return competitionId
  }

  get entityId(): Number {
    let entityId: Number = null;

    if (this.currentLinkModel?.params?.id) {
      entityId = parseInt(this.currentLinkModel?.params?.id)
    }

    return entityId
  }

  @override get currentLinkModel(): BaseLinkModel {
    return this.navigationManager.currentLinkModel;
  }

  get refreshLinkModel(): BaseLinkModel {
    return this._createRefreshLink(this.headerModel?.entityVM.linkModel);
  }

  get currentRefreshLinkModel(): BaseLinkModel {
    return this._createRefreshLink(this.headerModel?.activeLink) || this.refreshLinkModel;
  }

  get isPopulated(): Boolean {
    return true
  }

  _createRefreshLink(link) {
    if (!link) {
      return null;
    }

    const settings: BaseLinkModelSettings = new BaseLinkModelSettings(false, true);
    const linkModel = link.clone(settings);

    return linkModel;
  }

  get minFollowValue(): Number {
    return this.appState.minFollowValue;
  }
}
